import type { ReactNode } from 'react';
import type { Tone } from './tone';

const TONES: Record<Tone, string> = {
    neutral: 'border-slate-200 bg-slate-50 text-slate-700 dark:border-slate-800 dark:bg-slate-900 dark:text-slate-300',
    brand: 'border-brand-200 bg-brand-50 text-brand-900 dark:border-brand-900 dark:bg-brand-950 dark:text-brand-200',
    positive:
        'border-emerald-200 bg-emerald-50 text-emerald-900 dark:border-emerald-900 dark:bg-emerald-950 dark:text-emerald-200',
    warning: 'border-amber-200 bg-amber-50 text-amber-900 dark:border-amber-900 dark:bg-amber-950 dark:text-amber-200',
    critical: 'border-rose-200 bg-rose-50 text-rose-900 dark:border-rose-900 dark:bg-rose-950 dark:text-rose-200'
};

/**
 * Something the page needs to say, in place rather than in a toast.
 *
 * **A failure is announced, not merely coloured.** `critical` and `warning` carry `role="alert"`, so
 * a customer using a screen reader is told the upload was refused at the moment it was refused
 * rather than on their next pass down the page. The quieter tones do not, because a confirmation
 * that interrupts is worse than one that waits.
 */
export function Alert({ tone = 'critical', children }: { tone?: Tone; children: ReactNode }) {
    const urgent = tone === 'critical' || tone === 'warning';

    return (
        <div
            role={urgent ? 'alert' : undefined}
            className={`rounded-xl border px-4 py-3 text-sm ${TONES[tone]}`}
        >
            {children}
        </div>
    );
}
